/**
 * Tip percentages are proto floats, so over the binary transport they arrive widened
 * (7.7 becomes 7.699999809265137). Round them to 3 decimal places everywhere they are
 * shown or saved; the backend applies the same rounding on save and when it seeds the
 * default tip, so labels stay clean and tip amounts match the portal's buttons.
 */
export function roundTipPercentage(percentage: number): number {
  return Math.round(percentage * 1000) / 1000
}
